// src/modules/finan/hooks/useExportInstallmentsExcel.ts
import { useToast } from "../../../shared/hooks";
import { ToastContent } from "../../../shared/components";
import { FinancialService } from "../../../shared/services/api/financial/FinancialService";
import { globalFormatCurrencyBRL, globalMaskDocument, globalTranslateMethodPayment, globalTranslateStatusInvoices } from "../../../shared/utils";
import logo from "../../../assets/logo_report.png";
import { exportExcelWithStyle } from "../utils/exportExcel";
import { formatDateFnsRemoveTimezone } from "../../../shared/utils/format-date";

export const useExportInstallmentsExcel = (dataIni: string, dataFim: string, paymentMethod: "credit_card" | "billet", setIsLoading: (v: boolean) => void) => {
	const toastHandler = useToast();

	const handleExportCsv = async (clientId: string, clientName: string) => {
		setIsLoading(true);

		try {
			const result = await FinancialService.getInstallmentbyDocument(1, 10000, clientId, dataIni, dataFim, "Todos", paymentMethod);

			if (result instanceof Error || !result.data.length) {
				toastHandler.present({
					type: "error",
					position: "top-right",
					messageOrContent: <ToastContent title="Erro" content="Não foi possivel baixar o arquivo." />,
				});
				return;
			}

			await exportExcelWithStyle({
				title: `Relatório de Cobranças - ${clientName}`,
				subtitle: `Período: ${dataIni} a ${dataFim}`,
				data: result.data.map((item: any) => ({
					name: item.name,
					document: globalMaskDocument(item.document),
					certificate: item.certificate_number,
					amount: globalFormatCurrencyBRL(item.Installment_amount),
					due_date: formatDateFnsRemoveTimezone(item.Installment_due_date),
					payment_method: globalTranslateMethodPayment(item.Installment_payment_method),
					status: globalTranslateStatusInvoices(item.Installment_status),
					obs: item.Installment_obs ?? "-",
				})),
				columns: [
					{ key: "name", label: "Nome" },
					{ key: "document", label: "Documento" },
					{ key: "certificate", label: "Certificado" },
					{ key: "amount", label: "Valor" },
					{ key: "due_date", label: "Vencimento" },
					{ key: "payment_method", label: "Forma de Pagamento" },
					{ key: "status", label: "Status" },
					{ key: "obs", label: "Observação" },
				],
				logoBase64: logo,
				fileName: `relatorio-cobrancas-${clientName}.xlsx`,
			});
		} catch (err) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Erro" content="Falha ao exportar os dados para Excel" />,
			});
		} finally {
			setIsLoading(false);
		}
	};

	return { handleExportCsv };
};
